<template>
  <MainCard
    class="pa-6"
  >
    <template v-slot:body>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <h2>Hasil Vote</h2>
              <small>Halaman untuk hasil pemilihan</small>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="search"
                :append-icon="icons.mdiMagnify"
                label="Search"
                single-line
                hide-details
                dense
                outlined
                class=""
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-for="(itemResultEvoting, index) in searchedEvoting"
          :key="index"
          cols="4"
        >
          <v-card
            height="100%"
          >
            <v-card-title>
              {{ itemResultEvoting.name }}
            </v-card-title>
            <v-card-subtitle>
              Hasil Vote {{ itemResultEvoting.name }}
            </v-card-subtitle>
            <v-card-text>
              <apex-chart-expense-ratio :candidate="itemResultEvoting"></apex-chart-expense-ratio>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </MainCard>
</template>

<script>
import { mdiMagnify } from '@mdi/js'
import { computed, onMounted, ref, watch } from '@vue/composition-api'
import MainCard from '@/views/components/MainCard.vue'
import ApexChartExpenseRatio from './ApexChartExpenseRatio.vue'

export default {
  name: 'EvotingResult',
  components: {
    ApexChartExpenseRatio,
    MainCard,
  },
  setup(props, context) {
    const icons = {
      mdiMagnify,
    }
    const page = ref(1)
    const search = ref('')
    const totalPages = ref(0)
    const totalItems = ref(0)
    const isLoadingCard = ref(true)
    const isLoadingData = ref(false)
    const isLoadingButton = ref(false)

    const resultsEvoting = ref([])

    const school = ref('')
    const schoolUuid = ref('')
    const userUuid = ref('')

    const getSchoolUuid = () => {
      school.value = JSON.parse(localStorage.getItem('user')).user.details
      school.value.forEach(el => {
        if (el.school === undefined) {
          schoolUuid.value = el.uuid

          return
        }

        if (el.school === null) {
          return
        }
        userUuid.value = JSON.parse(localStorage.getItem('user')).user.uuid
        schoolUuid.value = el.school.uuid
      })

      return true
    }

    const listResultEvoting = async (params = {}) => {
      isLoadingData.value = true
      await context.root.$services.ApiServices.list('evoting', {
        ...params,
        role: 'admin',
        school_uuid: schoolUuid.value,
        page: page.value,
      }).then(
        ({ data }) => {
          resultsEvoting.value = data.data.map((resultsEvoting, index) => ({
            ...resultsEvoting,
            index: index + 1,
          }))
          totalItems.value = data.meta.total
          totalPages.value = data.meta.last_page
        },
        err => {
          console.error(err)
        },
      )
      isLoadingCard.value = false
      isLoadingData.value = false
    }

    const searchedEvoting = computed(() =>
      resultsEvoting.value.filter(result => result.name.toLowerCase().indexOf(search.value.toLowerCase()) !== -1),
    )

    watch(page, listResultEvoting)

    onMounted(() => {
      getSchoolUuid()
      listResultEvoting()
    })

    return {
      school,
      schoolUuid,
      userUuid,
      getSchoolUuid,
      icons,
      page,
      watch,
      search,
      onMounted,
      searchedEvoting,
      isLoadingData,
      isLoadingCard,
      isLoadingButton,
      listResultEvoting,
      resultsEvoting,
    }
  },
}
</script>

<style>
</style>
